import { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Toggle } from "@/components/ui/toggle";
import { Crown } from 'lucide-react';
import { LessonFormData } from './types';
import { RichTextEditor } from './RichTextEditor';
import { MediaUploadFields } from './MediaUploadFields';

interface BasicFieldsProps {
  form: UseFormReturn<LessonFormData>;
}

export const BasicFields: FC<BasicFieldsProps> = ({ form }) => {
  const levels = [
    { value: 'principiante', label: 'Principiante' },
    { value: 'intermedio', label: 'Intermedio' },
    { value: 'avanzado', label: 'Avanzado' }
  ];

  return (
    <div className="space-y-6">
      {/* Título */}
      <FormField
        control={form.control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Título de la Lección</FormLabel>
            <FormControl>
              <Input 
                placeholder="Introduce el título" 
                {...field} 
                className="text-lg"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Nivel y Premium */}
      <div className="flex items-center gap-6">
        <FormField
          control={form.control}
          name="level"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormLabel>Nivel</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Selecciona el nivel" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {levels.map((level) => (
                    <SelectItem key={level.value} value={level.value}>
                      {level.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="is_premium"
          render={({ field }) => (
            <FormItem>
              <FormLabel>&nbsp;</FormLabel>
              <FormControl>
                <Toggle
                  pressed={field.value}
                  onPressedChange={field.onChange}
                  className="data-[state=on]:bg-amber-500"
                >
                  <Crown className={`h-4 w-4 mr-2 ${field.value ? 'text-white' : ''}`} />
                  {field.value ? 'Premium' : 'Gratuito'}
                </Toggle>
              </FormControl>
            </FormItem>
          )}
        />
      </div>

      {/* Contenido */}
      <FormField
        control={form.control}
        name="content_text"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Contenido de la Lección</FormLabel>
            <FormControl>
              <RichTextEditor
                value={field.value || ''}
                onChange={field.onChange}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Media Upload */}
      <MediaUploadFields form={form} />
    </div>
  );
};